document.documentElement.classList.remove('no-js');
(() => {
 let active=null,opener=null;
 const focusable=()=>[...active.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
 function close(){if(!active)return;active.classList.remove('is-open');active.setAttribute('aria-hidden','true');active.inert=true;opener?.setAttribute('aria-expanded','false');document.documentElement.classList.remove('wyper-lock');document.body.classList.remove('wyper-lock');const last=opener;active=null;last?.focus();}
 document.querySelectorAll('[data-filter-drawer],[data-mobile-drawer]').forEach(el=>{el.inert=true;});
 document.addEventListener('click',e=>{
  const open=e.target.closest('[data-filter-open],[data-mobile-toggle]');
  if(open){const panel=document.querySelector(open.hasAttribute('data-filter-open')?'[data-filter-drawer]':'[data-mobile-drawer]');if(!panel)return;close();active=panel;opener=open;active.inert=false;active.classList.add('is-open');active.setAttribute('aria-hidden','false');opener.setAttribute('aria-expanded','true');document.documentElement.classList.add('wyper-lock');document.body.classList.add('wyper-lock');(focusable()[0]||active.querySelector('[role=dialog]'))?.focus();}
  if(e.target.closest('[data-filter-close],[data-mobile-close]'))close();
 });
 document.addEventListener('keydown',e=>{
  if(e.key==='Escape'){close();document.querySelectorAll('.w4-mobile-menu[open]').forEach(el=>{el.open=false;el.querySelector('summary')?.focus();});return;}
  if(!active||e.key!=='Tab')return;const list=focusable(),first=list[0],last=list.at(-1);if(!first){e.preventDefault();return;}if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
 });
})();
(() => {
 const clamp=(value,min,max)=>Math.min(Math.max(value,min),max);
 const update=(gallery,index)=>{
  const slides=gallery.querySelectorAll('[data-card-slide]');
  if(!slides.length)return;
  const next=clamp(index,0,slides.length-1);
  gallery.dataset.cardIndex=String(next);
  gallery.querySelector('[data-card-track]').style.transform=`translate3d(${-next*100}%,0,0)`;
  const previous=gallery.querySelector('[data-card-previous]');
  const following=gallery.querySelector('[data-card-next]');
  if(previous)previous.disabled=next===0;
  if(following)following.disabled=next===slides.length-1;
 };
 document.addEventListener('click',e=>{
  const control=e.target.closest('[data-card-previous],[data-card-next]');
  if(control){e.preventDefault();e.stopPropagation();const gallery=control.closest('[data-card-gallery]'),index=Number(gallery.dataset.cardIndex||0);update(gallery,index+(control.hasAttribute('data-card-next')?1:-1));return;}
  const link=e.target.closest('.product-card__media-link');
  if(link?.closest('[data-card-gallery]')?.dataset.suppressClick==='true'){e.preventDefault();}
 },true);
 document.addEventListener('pointerdown',e=>{
  const track=e.target.closest('[data-card-track]');
  if(!track||e.button!==0)return;
  const gallery=track.closest('[data-card-gallery]');
  if(gallery.querySelectorAll('[data-card-slide]').length<2)return;
  gallery._wyperGesture={id:e.pointerId,x:e.clientX,y:e.clientY,moved:false};
  track.setPointerCapture?.(e.pointerId);
 });
 document.addEventListener('pointermove',e=>{
  const track=e.target.closest('[data-card-track]');
  const gallery=track?.closest('[data-card-gallery]');
  const gesture=gallery?._wyperGesture;
  if(!gesture||gesture.id!==e.pointerId)return;
  const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
  if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){gesture.moved=true;gallery.classList.add('is-dragging');}
 });
 const finish=e=>{
  const galleries=document.querySelectorAll('[data-card-gallery]');
  galleries.forEach(gallery=>{
   const gesture=gallery._wyperGesture;
   if(!gesture||gesture.id!==e.pointerId)return;
   if(gesture.moved){
    const dx=e.clientX-gesture.x,index=Number(gallery.dataset.cardIndex||0);
    if(Math.abs(dx)>35)update(gallery,index+(dx<0?1:-1));
    gallery.dataset.suppressClick='true';
    setTimeout(()=>{delete gallery.dataset.suppressClick;},0);
   }
   gallery.classList.remove('is-dragging');delete gallery._wyperGesture;
  });
 };
 document.addEventListener('pointerup',finish);
 document.addEventListener('pointercancel',finish);
})();
(() => {
 document.addEventListener('click',e=>{
  const toggle=e.target.closest('[data-filter-toggle]');
  if(toggle){
   const scope=toggle.closest('.wyper-search-results,.wyper-collection');
   const panel=scope?.querySelector('[data-filter-panel]');
   if(!panel)return;
   const opening=panel.hidden;
   panel.hidden=!opening;
   toggle.setAttribute('aria-expanded',String(opening));
   if(opening)panel.querySelector('summary,button,input,a')?.focus();
   return;
  }
  const option=e.target.closest('[data-variant-value]');
  if(option){
   const picker=option.closest('[data-variant-picker]');
   const product=option.closest('[data-wyper-product]');
   const select=product?.querySelector('[data-wyper-variant]');
   if(!picker||!select||option.disabled)return;
   select.value=option.dataset.variantValue;
   select.dispatchEvent(new Event('change',{bubbles:true}));
   picker.querySelector('[data-variant-label]').textContent=option.dataset.variantLabel;
   picker.querySelectorAll('[data-variant-value]').forEach(button=>button.setAttribute('aria-pressed',String(button===option)));
   picker.open=false;
  }
 });
})();

